export enum ErrorScope {
    Local = "local",
    Global = "global",
}

const ErrorScopeContextIdentifier = "errorScope";

export const LocalErrorScopeApolloContext = { [ErrorScopeContextIdentifier]: ErrorScope.Local };

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const errorScopeForOperationContext = (context: any): ErrorScope => {
    const errorContext = context[ErrorScopeContextIdentifier];
    if (errorContext == ErrorScope.Local) {
        return ErrorScope.Local;
    }

    return ErrorScope.Global;
};
